import { useAsclepius } from "@/composables/api/asclepius"
import { watch, reactive } from "vue"

export const uselistLabOrdersFacade = () => {
  const { getLabOrderingApi, call, callResult } = useAsclepius()
  const labOrders = reactive({
    results: [],
    currPage: 1,
    nextPage: null,
    prevPage: null,
    pageCount: null,
    total: null
  })

  async function listLabOrders({
    facadeType,
    status,
    memberId,
    encounterId,
    appointmentProviderId,
    labName,
    testCodeableConceptId,
    createdEndDatetime,
    createdStartDatetime
  }) {
    await call(() =>
      getLabOrderingApi().listLabOrdersFacade({
        facadeType,
        status,
        memberId,
        encounterId,
        appointmentProviderId,
        labName,
        testCodeableConceptId,
        createdEndDatetime,
        createdStartDatetime,
        page: labOrders.currPage
      })
    )
  }

  watch(callResult, () => {
    if (callResult.value.isSuccess()) {
      const data = callResult.value.getData()
      labOrders.results = data.results
      labOrders.nextPage = data.next
      labOrders.prevPage = data.previous
      labOrders.total = data.count
      labOrders.pageCount = Math.ceil(data.results.count / 20)
    }
  })

  return {
    labOrders,
    listLabOrdersResult: callResult,
    listLabOrders
  }
}
